var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-sidebar",class:{ show:_vm.rightsidebar_toggle_var },attrs:{"id":"right_side_bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }